import React from "react";
import {
  Typography,
} from "@mui/material";
import AdvertisementOne from "../../Components/Advertisement/HOMEADVERTISEMENT";
import useGetActivityByType from "../../hooks/useGetActivityByType";
import { Link } from "react-router-dom";
import Loader from "../../Components/Loader";

const ComptetiveDetails = () => {
  const { activity, loading: activityLoading } = useGetActivityByType('COMPTETIVE');

  if (activityLoading) {
    return <Loader />;
  }

  return (
    <div className="px-4 md:px-10 my-10">
      <div className="flex flex-col gap-4">
        {activity && (
          <>
            <Typography sx={{ fontSize: '3rem' }} component="div" textTransform={'uppercase'} gutterBottom>
              {activity?.title}
            </Typography>

            <Typography variant="body1" color="text.secondary">
              <div dangerouslySetInnerHTML={{ __html: activity?.description }} />
            </Typography>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 my-8">
              <Link className="min-w-[80px]  hover:opacity-80 transition-all ease-in-out  duration-300 w-full h-[80px] flex items-center justify-center bg-[#fec749]" to={`/comp3x3tryout`}>
                Sign Up Tryout For 3x3
              </Link>
              <Link className="min-w-[80px]  hover:opacity-80 transition-all ease-in-out  duration-300 w-full h-[80px] flex items-center justify-center bg-[#fec749]" to={`/comp5x5tryout`}>
                Sign Up Tryout For 5x5
              </Link>
            </div>

          </>
        )}
      </div>

      <AdvertisementOne index={0} />
    </div>
  );
};

export default ComptetiveDetails;
